<template>
  <div style="position: relative;">
    <mylogin flag="1"></mylogin>
    <div class="Recharge-div">
      <div class="Recharge">
        <div class="Recharge-head">
          <p class="Recharge-head-p">充值中心</p>
        </div>
        <div class="Recharge-con">
          <div class="Recharge-con-left">
            <img src="../../img/grzx.png" alt class="Recharge-con-left-img" />
            <p class="Recharge-con-left-p">用户昵称</p>
          </div>
          <div class="Recharge-con-right">
            <img src="../../img/money.png" alt class="Recharge-con-right-img" />
            <p class="Recharge-con-right-p">0</p>
          </div>
        </div>
        <div class="Recharge-list">
          <div class="Recharge-list-one">
            <img src="../../img/money.png" alt class="Recharge-list-one-img" />
            <p class="Recharge-list-one-p">100羁绊币</p>
            <p class="Recharge-list-one-p1">1人民币</p>
          </div>
          <div class="Recharge-list-one">
            <img src="../../img/money.png" alt class="Recharge-list-one-img" />
            <p class="Recharge-list-one-p">100羁绊币</p>
            <p class="Recharge-list-one-p1">1人民币</p>
          </div>
          <div class="Recharge-list-one">
            <img src="../../img/money.png" alt class="Recharge-list-one-img" />
            <p class="Recharge-list-one-p">100羁绊币</p>
            <p class="Recharge-list-one-p1">1人民币</p>
          </div>
          <div class="Recharge-list-one">
            <img src="../../img/money.png" alt class="Recharge-list-one-img" />
            <p class="Recharge-list-one-p">100羁绊币</p>
            <p class="Recharge-list-one-p1">1人民币</p>
          </div>
        </div>
        <p class="Recharge-p">支付方式</p>
        <div class="Recharge-foot">
          <div class="Registcon-foot-left">
            <img src="../../img/zfb.png" alt class="Registcon-foot-left-img" />
            <p class="Registcon-foot-left-p">支付宝</p>
          </div>
          <div class="Registcon-foot-left">
            <img src="../../img/wx.png" alt class="Registcon-foot-left-img" />
            <p class="Registcon-foot-right-p">微信</p>
          </div>
        </div>
        <div class="Recharge-foot-div">
          <button type="button" class="Recharge-btn">立即购买</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import mylogin from "../mylogin.vue";

export default {
  name: "App",

  components: {
    mylogin
  }
};
</script>

<style>
.Recharge {
  width: 802px;
  height: 588px;
  padding: 30px 101px;
  box-sizing: border-box;
  background-color: #f5f5f5;
  position: absolute;
  top: 100px;
  box-sizing: border-box;
}

.Recharge-div {
  width: 100%;
  display: flex;
  justify-content: center;
}

.Recharge-head {
  width: 100%;
  height: 65px;
  display: flex;
  justify-content: center;
}

.Recharge-head-p {
  width: 209px;
  height: 65px;
  box-sizing: border-box;
  border-bottom: 1px solid #b3b3b3;
  font-size: 16px;
  text-align: center;
  line-height: 65px;
  color: #212121;
}

.Recharge-con {
  margin: 0 auto;
  width: 250px;
  display: flex;
  justify-content: space-between;
  padding: 20px 0;
}

.Recharge-con-left {
  display: flex;
  align-items: center;
}

.Recharge-con-left-img {
  width: 36px;
  height: 36px;
  margin-right: 10px;
}

.Recharge-con-left-p {
  font-size: 16px;
  color: #212121;
}

.Recharge-con-right {
  display: flex;
  align-items: center;
}

.Recharge-con-right-img {
  width: 34px;
  height: 34px;
  margin-right: 10px;
}

.Recharge-con-right-p {
  font-size: 16px;
  color: #212121;
}

.Recharge-list {
  width: 100%;
  padding: 30px 0 60px;
  display: flex;
  justify-content: space-between;
}

.Recharge-list-one {
  width: 120px;
  height: 110px;
  padding: 10px;
  box-sizing: border-box;
  border: 1px solid #cccccc;
  border-radius: 6px;
}
.Recharge-list-one:hover {
  box-sizing: border-box;
  border: 1px solid #28a3b1;
}
.Recharge-list-one-img {
  width: 30px;
  height: 30px;
  margin: 0 auto;
}

.Recharge-list-one-p {
  margin: 10px auto;
  text-align: center;
  font-size: 16px;
  color: #212121;
}

.Recharge-list-one-p1 {
  margin: 10px auto;
  text-align: center;
  font-size: 12px;
  color: #212121;
}
.Recharge-p {
  font-size: 16px;
  color: #212121;
  text-align: center;
  margin-bottom: 40px;
}
.Recharge-foot {
  width: 250px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
}
.Registcon-foot-left {
  display: flex;
  align-items: center;
  font-weight: 600;
  padding: 4px 6px;
  border: rgba(255, 255, 255, 0) 1px solid;
}
.Registcon-foot-left:hover {
  border: #28a3b1 1px solid;
  box-sizing: border-box;
}
.Registcon-foot-left-img {
  width: 37px;
  height: 37px;
  margin-right: 10px;
}
.Registcon-foot-left-p {
  font-size: 13px;
  color: #212121;
}
.Registcon-foot-right-p {
  font-size: 13px;
  color: #212121;
}
.Recharge-btn {
  width: 150px;
  height: 44px;
  border-radius: 6px;
  background-color: #28a3b1;
  color: #fff;
  border: 0;
  font-size: 14px;
  margin-top: 30px;
}
.Recharge-foot-div {
  width: 100%;
  display: flex;
  justify-content: center;
}
</style>



// WEBPACK FOOTER //
// src/components/Recharge/Recharge.vue